import React from "react";
import { Navigate } from "react-router-dom";
import { RouterAddress } from "../../../constants/RouterAddress";

export default function FacilityAdminDashboard() {
  return <Navigate to={RouterAddress.PROVIDER_HOME} replace />;
}
